import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateValueItem } from "../../api/apiValueItems";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export function useUpdateValueItem() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: updateItemMutate, isPending } = useMutation({
        mutationFn: ({ id, data }) => updateValueItem(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["value-items"] });
            navigate("/values");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update value item");
        },
    });

    return { updateItemMutate, isPending };
}
